import { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

export const BannerSection = ({ translations }: { translations: Record<string, any> }) => {
  useEffect(() => {
    AOS.init({
      duration: 600,
      easing: 'ease-out-quad',
      once: true,
      offset: 120,
      delay: 100,
    });

    return () => {
      AOS.refresh();
    };
  }, []);

  return (
    <section className="bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-800 dark:to-gray-900 py-12 border-t border-b border-gray-200 dark:border-gray-700">
      <div className="container mx-auto px-5">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          <div
            className="flex-1 min-w-[300px]"
            data-aos="fade-right"
            data-aos-delay="150"
          >
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-3">
              {translations.heading}
            </h2>
            <p className="text-lg text-gray-600 dark:text-gray-300 leading-relaxed">
              {translations.description}
            </p>
          </div>

          <div
            className="flex flex-col sm:flex-row gap-4 w-full md:w-auto"
            data-aos="fade-left"
            data-aos-delay="300"
          >
            <a
              href="/dashboard/consultant-profile/edit"
              className="flex items-center justify-center gap-2 px-6 py-3 rounded-lg font-semibold text-white bg-blue-500 hover:bg-blue-600 dark:bg-blue-600 dark:hover:bg-blue-700 transition-all duration-300 transform hover:-translate-y-1 focus:outline-none focus:ring-4 focus:ring-blue-300/50 dark:focus:ring-blue-700/50 shadow-md hover:shadow-lg relative overflow-hidden"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="w-5 h-5"
              >
                <path
                  fillRule="evenodd"
                  d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zM12.75 9a.75.75 0 00-1.5 0v2.25H9a.75.75 0 000 1.5h2.25V15a.75.75 0 001.5 0v-2.25H15a.75.75 0 000-1.5h-2.25V9z"
                  clipRule="evenodd"
                />
              </svg>
              {translations.register}
            </a>

            <a
              href="/dashboard/consultant-profile"
              className="flex items-center justify-center gap-2 px-6 py-3 rounded-lg font-semibold text-blue-600 dark:text-blue-400 border-2 border-blue-500 dark:border-blue-600 hover:bg-blue-50/50 dark:hover:bg-gray-700/50 transition-all duration-300 transform hover:-translate-y-1 focus:outline-none focus:ring-4 focus:ring-blue-300/30 dark:focus:ring-blue-700/30 shadow-sm hover:shadow-md relative overflow-hidden"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="w-5 h-5"
              >
                <path
                  fillRule="evenodd"
                  d="M7.5 6a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM3.751 20.105a8.25 8.25 0 0116.498 0 .75.75 0 01-.437.695A18.683 18.683 0 0112 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 01-.437-.695z"
                  clipRule="evenodd"
                />
              </svg>
              {translations.dashboard}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};